import { createAction } from '@reduxjs/toolkit';

export const updateIsProjectPublic = createAction<{ tabId: string; isPublic: boolean }>(
  'aiWriter/updateIsProjectPublic'
);
